import ButtonComponent from "../shared/button/button.component"
import { buttonLabels } from "../shared/constants"

interface IProps {
    IsDarkMode: boolean
    FileName?: string
    OnViewReports: () => void
    OnUploadAnother: () => void
}

const CreateUsersResultStep = (props: IProps) => {
    return (
        <div className={`w-p-100 mt-2 br-3 py-5 px-3 ${props.IsDarkMode ? "bg-color-primary-background" : "bg-color-secondary"}`}>
            <div className="d-flex flex-direction align-center">
                <div
                    className="d-flex align-center justify-center br-50"
                    style={{ width: 56, height: 56, backgroundColor: "#E7F6EE" }}
                >
                    <svg width="22" height="22" viewBox="0 0 14 14" fill="none">
                        <path d="M2.9165 7.58334L5.24984 9.91667L11.0832 4.08334" stroke="#3CB371" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="h2-medium color-primary-accent mt-2" style={{ fontFamily: "silkasemibold", textAlign: "center" }}>
                    Bulk user import success report will be generated
                </div>
                {!!props.FileName && (
                    <div className="h5-regular color-text-field-label mt-1">
                        {props.FileName}
                    </div>
                )}
                <div className="h5-regular color-text-field-label mt-1" style={{ textAlign: "center", maxWidth: 520 }}>
                    User creation runs in the background. Open import reports to see saved and ignored users once the report is ready.
                </div>
            </div>

            <div className="d-flex align-center justify-center mt-4">
                <ButtonComponent
                    ButtonLabel={buttonLabels.VIEW_REPORTS}
                    Variant="primary-btn"
                    ClassName="m-0 pt-2 pb-2 br-2"
                    buttonProps={{ style: { textTransform: "none", fontFamily: "silkamedium", fontSize: "1rem" } }}
                    OnClick={props.OnViewReports}
                />
                <ButtonComponent
                    ButtonLabel="Upload another file"
                    Variant="secondary-btn"
                    ClassName="m-0 ml-2 pt-2 pb-2 br-2"
                    buttonProps={{ style: { textTransform: "none", fontFamily: "silkamedium", fontSize: "1rem" } }}
                    OnClick={props.OnUploadAnother}
                />
            </div>
        </div>
    )
}

export default CreateUsersResultStep
